import ApiService from '@/app/framework/services/ApiServices'
import { PositionDataMapper } from '@/data/persistences/mappers/PositionDataMapper'
import { PositionRepositoryInterface } from '@/data/persistences/repositories/contracts/PositionRepositoryInterface'
import { Position, PositionDnet } from '@/domain/entities/Position'
import { Endpoints } from '@/app/framework/misc/Endpoints'
import {
  PositionApiRequest,
  UpdatePositionRequest,
} from '@/data/payload/api/PositionRequest'
import {
  PostPositionInterface,
  DeletePositionInterface,
  UpdatePositionInterface,
} from '@/data/payload/contracts/PositionRequest'

export class PositionApiRepository implements PositionRepositoryInterface {
  private service: ApiService
  private mapper: PositionDataMapper

  constructor(service: ApiService, mapper: PositionDataMapper) {
    this.service = service
    this.mapper = mapper
  }

  public async getAll(): Promise<Position> {
    const resp = await this.service.invoke('get', Endpoints.Route.POSITION)
    return this.mapper.convertFromApi(resp)
  }

  public async getAllDnet(): Promise<PositionDnet> {
    const resp = await this.service.invoke('get', Endpoints.Route.POSITION_DNET)
    return this.mapper.convertFromApiDnet(resp)
  }

  public async delete(payload: DeletePositionInterface): Promise<Position> {
    const resp = await this.service.invoke(
      'post',
      Endpoints.Route.POSITION_DELETE,
      undefined,
      payload as PositionApiRequest
    )
    return this.mapper.convertBaseResponseFromApi(resp)
  }

  public async update(
    payload: UpdatePositionInterface,
    id: number
  ): Promise<Position> {
    const resp = await this.service.invoke(
      'post',
      `${Endpoints.Route.POSITION}/${id}`,
      undefined,
      payload as UpdatePositionRequest
    )
    return this.mapper.convertBaseResponseFromApi(resp)
  }

  public async post(payload: PostPositionInterface): Promise<Position> {
    const resp = await this.service.invoke(
      'post',
      Endpoints.Route.POSITION,
      undefined,
      payload as PositionApiRequest
    )
    return this.mapper.convertBaseResponseFromApi(resp)
  }
}
